import { type ComponentType, lazy } from "react";

const RELOAD_KEY = "chunk-reload-at";
const RELOAD_COOLDOWN_MS = 10_000;

export function reloadForStaleChunk(
  reload: () => void = () => window.location.reload()
): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {}
  reload();
  return true;
}

export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  reload?: () => void
) {
  return lazy(() =>
    factory().catch((err) => {
      if (reloadForStaleChunk(reload)) {
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    })
  );
}
